import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import LocationSelection from "./components/LocationSelection";
import Reports from "./components/Reports";
import AdSpendEntry from "./components/AdSpendEntry";
import Settings from "./components/Settings";
import OAuthCallback from "./components/OAuthCallback";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/oauth/callback" element={<OAuthCallback />} />
          <Route path="/select-location" element={<LocationSelection />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/ad-spend" element={<AdSpendEntry />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;